module.exports = __webpack_public_path__ + "img/windows.7e314252.svg";